import React, {Fragment, memo} from 'react';

interface DevToolWrapperProps {
  children: React.ReactNode;
}

export const DevToolWrapper = memo(({children}: DevToolWrapperProps) => {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  return <Fragment>{children}</Fragment>;
});
